export enum BusinessConceptSelectionMode {
    businessConceptSelectionModeAsync = 1,
    businessConceptSelectionModeEager = 4

}
